import { EventEmitter, Injectable } from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Escritorio } from "../models/escritorio.model";
import {
    ApiPaginationResponse,
    ApiResponse,
} from "app/shared/models/api-response.model";

// TODO: CHECK RESPONSES FOR THIS SERVICE

@Injectable()
export class EscritorioService {
    private baseUrl = "escritorio";
    constructor(
        private authService: AuthService,
        private _http: HttpClient,
        public utilitesService: UtilitesService
    ) {}

    /**
     * Empresa por id
     * @param id ID da empresa
     */
    getById(id: number): Observable<ApiResponse<Escritorio>> {
        return this._http.get<ApiResponse<Escritorio>>(
            this.utilitesService.urlPrefix + this.baseUrl + "/" + id,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Lista de Empresas
     * @param id ID da empresa
     */
    getAll(params: any): Observable<ApiPaginationResponse<Escritorio[]>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponse<Escritorio[]>>(
            this.utilitesService.urlPrefix + this.baseUrl + env,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Delete de Empresa
     * @param id ID da empresa
     */
    delete(id: number): Observable<any> {
        return this._http.delete(
            this.utilitesService.urlPrefix + this.baseUrl + "/" + id,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Cadastra Empresa
     * @param params Json Empresa
     */
    create(params: any): Observable<any> {
        return this._http.post(
            this.utilitesService.urlPrefix + this.baseUrl,
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Atualiza Empresa
     * @param params Json Empresa
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(
            this.utilitesService.urlPrefix + this.baseUrl + "/" + id,
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }
}
